import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import debounce from "lodash/debounce";

// context
import { useDropDown } from "../useDropDown";

// hooks
import { useOnClickOutside } from "js/hooks/useOnClickOutside";

//styles
const MountingWrapperStyled = styled.div`
    display: inline-block;
    position: relative;
`;

// MountingWrapper
const MountingWrapper = ({ children }) => {
    const {
        close,
        open,
        toggleOnHover,
        hideOnScroll,
        isOpen,
        dropDownRef,
        shouldFocus
    } = useDropDown();

    const onClickOutside = useCallback(() => {
        isOpen && close();
    }, [isOpen]);

    const { targetRef: mountingWrapperRef } = useOnClickOutside({
        onClickOutside
    });

    useEffect(() => {
        const onKeyDown = event => {
            if (event.key === "Escape") {
                close();
            }
        };
        const onScroll = debounce(() => {
            if (hideOnScroll) {
                close();
            }
        }, 300);

        // Add event listener
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("scroll", onScroll);

        // Cleanup the event listener
        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("scroll", onScroll);
        };
    }, [close, hideOnScroll]);

    const onMouseEnter = () => {
        if (toggleOnHover) open();
    };
    const onMouseLeave = () => {
        if (toggleOnHover) close();
    };

    // When Dialog opens, it should focus the first focusable element,
    // or the dialog itself.
    useEffect(() => {
        const dd = dropDownRef?.current;

        if (dd && shouldFocus) {
            const firstFocusable = dd?.querySelector(
                "button, input, textarea, select, a"
            );

            if (firstFocusable) {
                firstFocusable.focus();
            } else {
                dd.focus();
            }
        }
    }, [shouldFocus, dropDownRef]);

    return (
        <MountingWrapperStyled
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={mountingWrapperRef}
        >
            {children}
        </MountingWrapperStyled>
    );
};

export default MountingWrapper;

// prop-types
MountingWrapper.propTypes = {
    children: PropTypes.any
};
